import { TAB_ROLE_KEY } from './sessionKeys'

/**
 * Tracks which role owns this tab's sessionStorage state (list/report filters and
 * the saved post-login page). Both belong to a role: the same role re-authenticating
 * should resume the tab's workflow, while a different role scopes companies,
 * properties and residents differently and must start clean.
 */
function readTabRole(): string | null {
  try {
    return sessionStorage.getItem(TAB_ROLE_KEY)
  } catch {
    return null
  }
}

/** Filters: also reset when the owning role is unknown, so nothing leaks across roles. */
export function shouldResetTabFilters(roleId: number | string): boolean {
  return readTabRole() !== String(roleId)
}

/**
 * Saved page: only a *known* role change discards it. An unknown owner means the
 * tab was bounced to login before it ever recorded a role, so the page still stands.
 */
export function isTabRoleSwitch(roleId: number | string): boolean {
  const previous = readTabRole()
  return previous !== null && previous !== String(roleId)
}

export function rememberTabRole(roleId: number | string): void {
  try {
    sessionStorage.setItem(TAB_ROLE_KEY, String(roleId))
  } catch {
    /* ignore */
  }
}
